import { get } from 'lodash';

export const hasCapability = (user, capability) => get(user, 'capabilities', []).includes(capability);

export const isSuperAdmin = user => hasCapability(user, 'superadmin');
export const isContentManager = user => isSuperAdmin(user) || hasCapability(user, 'contentmanager');
export const isRetail = user => isSuperAdmin(user) || hasCapability(user, 'retail');
export const isAdmin = user => isSuperAdmin(user) || get(user, 'agency.admins', []).includes(get(user, 'userId', ''));
export const isMasqueradeFromSuperAdmin = user => !!get(user, 'masqueradeFromSuperAdmin');
export const isBasic = user => {
  return (
    !isRetail(user) || isSuperAdmin(user) || isAdmin(user) || hasCapability(user, 'contentmanager') || isMasqueradeFromSuperAdmin(user)
  );
};
export const isRetailOnly = user => isRetail(user) && !isBasic(user);

export const isAuthenticated = user => {
  return !!user;
};
